import { useEffect, useState } from "react";
import { ICustomAdjustmentConfig } from "../../../Interfaces/deltaHedgeAdjustment";
import {
  getCustomAdjustmentConfig,
  setCustomAdjustmentConfig,
} from "../../../Requests/deltaHedgeAdjustment";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getStepInstruments } from "../../../Requests/stepRequests";

interface IProps {
  onClose: () => void;
}

const CustomAdjustmentConfig = ({ onClose }: IProps) => {
  const [formValues, setFormValues] = useState({} as ICustomAdjustmentConfig);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getCustomAdjustmentConfig()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const submitHandler = () => {
    setLoading(true);
    setCustomAdjustmentConfig(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-center items-start gap-5 h-full">
      {loading ? <FullScreenLoading /> : <></>}
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "incremental",
          placeholder: "افزایشی",
          extraLabel: true,
        }}
        getData={getStepInstruments}
        onChange={changeHandler}
        value={formValues.incremental}
        withTagBox
      />
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "decremental",
          placeholder: "کاهشی",
          extraLabel: true,
        }}
        getData={getStepInstruments}
        onChange={changeHandler}
        value={formValues.decremental}
        withTagBox
      />
      <div className="mr-auto w-24">
        <Button text="ثبت" onClick={submitHandler} variant="contained" />
      </div>
    </div>
  );
};

export default CustomAdjustmentConfig;
